// extracted by mini-css-extract-plugin
export default {"container":"Investigation_container__iiehw","content":"Investigation_content__h16RN","controls":"Investigation_controls__4uGyZ"};